import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { User } from '@src/types/User'
import { useTranslation } from 'react-i18next'

interface Props {
  open: boolean
  user: User | null
  onClose: () => void
  onConfirm: () => void
  isActivating: boolean
}

const ManageUserDialog = ({ open, user, onClose, onConfirm, isActivating }: Props) => {
  const { t } = useTranslation()
  if (!user) return null

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('common.manageUserDialogTitle')}</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Typography>
            <strong>{t('common.firstName')}:</strong> {user.firstName}
          </Typography>
          <Typography>
            <strong>{t('common.lastName')}:</strong> {user.lastName}
          </Typography>
          <Typography>
            <strong>{t('UserStatsHeaders.accountStatus')}:</strong>{' '}
            {user.accountEnabled ? t('common.Active') : t('common.Inactive')}
          </Typography>
          <Typography>
            <strong>{t('UserStatsHeaders.jobTitle')}:</strong> {user.jobTitle}
          </Typography>
          <Typography>
            <strong>{t('common.phone')}:</strong> {user.phone}
          </Typography>
          <Typography>
            <strong>{t('common.email')}:</strong> {user.email}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color={isActivating ? 'success' : 'error'}>
          {isActivating ? t('common.confirmActivation') : t('common.confirmDeactivation')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ManageUserDialog
